module.exports = __webpack_public_path__ + "img/character-7.beede504.png";